module.exports = __webpack_public_path__ + "media/src/application/media/animation/loader_hearts-e647245fb1bca86ab23a3856a513c037.gif";